<div class="d-flex justify-content-center">
    <img src="https://focuspos-onlineorder-images.s3-us-west-2.amazonaws.com/Focus-With-Cloud-New-Trans.png"
        style="width: 300px; height: auto;" class="logo" alt="Focus POS Systems Logo" />
</div>


<div class="d-flex justify-content-center" >
    <div *ngIf="step === 0">
        <ngx-loading [show]="true"
            [config]="{primaryColour: 'rgb(255,114,0,0.75)', secondaryColour: 'rgb(255,114,0,0.75)', tertiaryColour: 'rgb(255,114,0,0.75)', backdropBackgroundColour: 'rgb(255,255,255,0)'}">
        </ngx-loading>
    </div>
    <div *ngIf="step === 1" style="max-width: 500px;">
        <input pPassword type="password" class="m-2 w-100" required name="password" placeholder="Password"
            promptLabel="Please enter a strong password" weakLabel="Low security" mediumLabel="Medium security" strongLabel="Strong security" [(ngModel)]="password.password">
        <input pInputText type="password" class="mt-2 ms-2 me-2 w-100" required name="confirmPassword" [(ngModel)]="password.confirmPassword" placeholder="Confirm password" />
        <div class="mb-2 ms-2 me-2">
            <span *ngIf="password.password && !password.confirmPassword">
                Please confirm your password.
            </span>
            <span *ngIf="password.password && password.confirmPassword && password.password !== password.confirmPassword">
                Sorry, your passwords do not match.
            </span>
        </div>
        <button pButton pRipple type="submit" class="ui-button-raised ui-button-rounded w-100 m-2" (click)="claimAccount()"
            label="Activate" [disabled]="!password.confirmPassword || password.password !== password.confirmPassword"></button>
    </div>
    <div *ngIf="step === 2" style="max-width: 500px;">
        <div class="mx-2 mt-5 mb-5"><h3>Welcome to FocusOnline!</h3></div>        
        <button pButton type="submit" class="ui-button-raised ui-button-rounded w-100" (click)="login()" label="Log In"></button>
    </div>
    <div *ngIf="step === 3"  style="max-width: 500px;">
        <div class="mx-2 mt-5 mb-5" style="text-align: center;">
            Your FocusOnline user account has already been claimed. 
        </div>
        <div class="m-2"  style="text-align: center;">
            <a routerLink="/login">Click here to log in.</a>
        </div>
    </div>
    <div *ngIf="step === 4" style="max-width: 500px;">
        <div class="m-2" style="text-align: center;">
            We encountered a problem with your account. Please contact support.
        </div>
        <div class="m-2" style="text-align: center;">
            <span style="font-size: small;">{{errorCondition}}</span>
        </div>
    </div>
</div>
